import React from 'react';
import styles from './AccessFetchError.module.scss';

export const AccessFetchError = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Oh no</h3>
      </div>
      <div className={styles.content}>
        <div>We had an issue fetching this information</div>
      </div>
    </div>
  );
};
